const a = "Cargando", o = {
  loading: a
};
export {
  o as default,
  a as loading
};
